import React, { useState } from 'react';
import { initMercadoPago, Wallet } from '@mercadopago/sdk-react';
import { Button, CircularProgress, Alert, Box } from '@mui/material';
import { MERCADO_PAGO_CONFIG, CHECKOUT_URLS } from '../../services/mercadoPagoConfig';
import './CheckoutMercadoPago.css';

// Inicializar Mercado Pago
initMercadoPago(MERCADO_PAGO_CONFIG.publicKey);

const CheckoutMercadoPago = ({ onClose }) => {
  const [preferenceId, setPreferenceId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createPreference = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch('https://trajetus.net/api/mercadopago/create-subscription', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          title: MERCADO_PAGO_CONFIG.subscriptionTitle,
          description: MERCADO_PAGO_CONFIG.subscriptionDescription,
          price: MERCADO_PAGO_CONFIG.subscriptionPrice,
          currency: MERCADO_PAGO_CONFIG.currency,
          frequency: 1,
          frequency_type: 'months',
          back_urls: CHECKOUT_URLS
        })
      });

      const data = await response.json();
      
      if (data.success) {
        setPreferenceId(data.preferenceId);
      } else {
        setError(data.message || 'Erro ao criar preferência de pagamento');
      }
    } catch (err) {
      setError('Erro de conexão. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="checkout-container">
      <div className="checkout-header">
        <h2>Finalizar Assinatura</h2>
        <p>Plano Mensal - R$ {MERCADO_PAGO_CONFIG.subscriptionPrice.toFixed(2)}</p>
      </div>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {!preferenceId ? (
        <Button
          variant="contained"
          onClick={createPreference}
          disabled={loading}
          fullWidth
          size="large"
          className="checkout-button"
        >
          {loading ? (
            <>
              <CircularProgress size={20} sx={{ mr: 1 }} />
              Processando...
            </>
          ) : (
            'Continuar com Mercado Pago'
          )}
        </Button>
      ) : (
        <Wallet
          initialization={{
            preferenceId: preferenceId,
            redirectMode: 'self'
          }}
          customization={{
            texts: {
              valueProp: 'smart_option'
            }
          }}
        />
      )}

      <Button
        variant="text"
        onClick={onClose}
        sx={{ mt: 2 }}
        fullWidth
      >
        Cancelar
      </Button>
    </Box>
  );
};

export default CheckoutMercadoPago;